import cls from 'clsx';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import { observer } from 'mobx-react-lite';
import { Left } from '@linktivity/link-icons';
import Logo from '@link/portal/assets/logo.svg?react';
import { useStore } from '@link/portal/stores';
import { DetailType } from '@link/portal/services/const';
import { LIMOUSINE_SUPPLIER_IDS } from '@link/portal/views/Limousine/constants';

import styles from './header.module.css';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { ticketData } = useStore();
  const supplierId = pathname.split('/')[2];
  const isLimousine = LIMOUSINE_SUPPLIER_IDS.includes(supplierId);
  const isEmotTicket = ticketData.ticket.detailType === DetailType.OdakyuTokkyu;

  return (
    <header className={cls(styles.header, isLimousine && styles.limousine)}>
      <div className={styles.inner}>
        {(isLimousine || isEmotTicket) && (
          <button
            type="button"
            className={styles.back}
            aria-label={t('common.back')}
            onClick={() => navigate(-1)}
          >
            <Left className={styles.backIcon} />
          </button>
        )}
        <Logo className={styles.logo} />
      </div>
    </header>
  );
};

const ObservedHeader = observer(Header);
export default ObservedHeader;
